import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Loader from './components/website/Loader';
import DashboardLayout from './components/admin/DashboardLayout';
import { useAuth } from './context/AuthContext';
import PageNotFound from './components/admin/PageNotFound';
import SliderImageIndex from './components/admin/masters/Sliders';
import SliderImageBody from './components/admin/masters/Sliders/Body';
import PartnerIndex from './components/admin/masters/Partner/PartnerIndex';
import PartnerBody from './components/admin/masters/Partner/PartnerBody';
import ProductTypeIndex from './components/admin/masters/ProductType/index';
import ProductTypeBody from './components/admin/masters/ProductType/Body';
import ProductIndex from './components/admin/masters/Product/index';
import ProductBody from './components/admin/masters/Product/Body';
import GalleryIndex from './components/admin/masters/Gallery/GalleryIndex';
import GalleryBody from './components/admin/masters/Gallery/GalleryBody';
import TenderIndex from './components/admin/masters/Tenders/TenderIndex';
import TenderBody from './components/admin/masters/Tenders/TenderBody';
import VacancyIndex from './components/admin/masters/vacancies/VacancyIndex';
import VacancyBody from './components/admin/masters/vacancies/vacancyBody';
import OrderIndex from './components/admin/masters/Order/index';
import OrderBody from './components/admin/masters/Order/Body';
import DealerIndex from './components/admin/masters/Dealer/DealerIndex';
import DealerBody from './components/admin/masters/Dealer/DealerBody';
import OfferIndex from './components/admin/offers/Partner/OfferIndex';
import OfferBody from './components/admin/offers/Partner/OfferBody';
import ContactUsIndex from './components/admin/masters/ContactUs/ContactUsIndex';
import StoryIndex from './components/admin/masters/Story/StoryIndex';
import StoryBody from './components/admin/masters/Story/StoryBody';

// Components
const AdminDashboard = lazy(() => import('./components/admin/AdminDashboard'));

function AdminRouter() {
    const { currentUser } = useAuth();

    if (!currentUser) {
        return <Navigate to="/login" replace />;
    }

    return (
        <Suspense fallback={<Loader />}>
            <Routes>
                <Route element={<DashboardLayout />}>
                    <Route index element={<AdminDashboard />} />
                    <Route path="dashboard" element={<AdminDashboard />} />
                    <Route path="sliders" element={<SliderImageIndex />} />
                    <Route path="sliders/:id" element={<SliderImageBody />} />

                    {/* Partner    */}
                    <Route path="partners" element={<PartnerIndex />} />
                    <Route path="partners/:id" element={<PartnerBody />} />

                      {/* gallery    */}
                    <Route path="galleries" element={<GalleryIndex />} />
                    <Route path="galleries/:id" element={<GalleryBody />} />

                    {/* tenders */}
                    <Route path="tenders" element={<TenderIndex />} />
                    <Route path="tenders/:id" element={<TenderBody />} />

                      {/* tenders */}
                    <Route path="offers" element={<OfferIndex />} />
                    <Route path="offers/:id" element={<OfferBody />} />
                    

                     {/* vacancy */}
                    <Route path="vacancies" element={<VacancyIndex />} />
                    <Route path="vacancies/:id" element={<VacancyBody />} />


                    {/* dealer */}
                    <Route path="dealers" element={<DealerIndex />} />
                    <Route path="dealers/:id" element={<DealerBody />} />

                     {/* dealer */}
                    <Route path="stories" element={<StoryIndex />} />
                    <Route path="stories/:id" element={<StoryBody />} />

                    {/* Contact Us */}
                    <Route path="contacts" element={<ContactUsIndex />} />

                    {/* Product Catalog */}
                    <Route path="categories" element={<ProductTypeIndex />} />
                    <Route path="categories/:id" element={<ProductTypeBody />} />
                    <Route path="products" element={<ProductIndex />} />
                    <Route path="products/:id" element={<ProductBody />} />
                    <Route path="orders" element={<OrderIndex />} />
                    <Route path="orders/:id" element={<OrderBody />} />

                    <Route path="*" element={<PageNotFound />} />
                </Route>
            </Routes>
        </Suspense>
    );
}

export default AdminRouter;